import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
  agentDetails: {
    name: "",
    email: "",
    profile_image: "",
    profile_image_ref: null,
    id: "",
  },

  resetPermissionsView: false,
};

export const agentSlice = createSlice({
  name: "agent",
  initialState,
  reducers: {
    setAgentDetails: (state, actions: PayloadAction<any>) => {
      state.agentDetails = actions.payload;
    },

    resetPermissionsView: (state) => {
      state.resetPermissionsView = !state.resetPermissionsView;
    },
  },
});

export const agentAction = agentSlice.actions;
export const agentReducer = agentSlice.reducer;
